<footer class="app-footer">
  <span>&copy; 2020</span>
</footer>
